import React, { Component } from "react";
import { DKLabel } from "deskera-ui-library";
import { PAGE_TYPE } from "../ComponentList";

/*
PROPS
- data // this is current components data
- onDataChange
- className
- pageType (PAGE_TYPE)
*/

class ButtonEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div
        className={
          "column parent-width border-box mt-m border-radius-s p-r border-m shadow-s " +
          this.props.className
        }
      >
        <DKLabel text="Web URL" className="fw-m" />
        <input
          className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s mt-r border-m text-blue"
          type="text"
          value={
            this.props.pageType === PAGE_TYPE.FUNNEL
              ? "Goto-next-step"
              : this.componentData.url
          }
          onChange={(e) => this.changeURL(e.target.value)}
          placeholder="https://www.example.com"
          readOnly={this.props.pageType === PAGE_TYPE.FUNNEL}
        />
      </div>
    );
  }
  changeURL(url) {
    this.componentData.url = url;
    this.props.onDataChange(this.componentData);
  }
}

export default ButtonEditor;
